import { render, staticRenderFns } from "./creator-v3-tags.vue?vue&type=template&id=6b5c714e"
import script from "./creator-v3-tags.js?vue&type=script&lang=js&external"
export * from "./creator-v3-tags.js?vue&type=script&lang=js&external"
import style0 from "./creator-v3-tags.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports